/**
 * Composition method for EPIC HR App content
 * 
 * Author: Andrea López
 */
 import { computed, onMounted } from 'vue';
 import { useRoute } from 'vue-router';
 import { useStore } from 'vuex';

export function epicContentComposition () {
    const store = useStore();
	const route = useRoute();

    // Screen computed
    const screen = computed((): string => store.getters.get_ehrScreen);

    // function navigate to screen
    function switchScreen (screenTo: string) {
        store.dispatch('axn_updateEhrScreen', screenTo);
    }

    // Query listener and navigation
    function queryListener () {
		if (!route.query) { return; }

		const { screen } = route.query;
		if (!screen) { return; }

		store.dispatch('axn_updateEhrScreen', screen);
	}

    // Mounted lifecycle
	onMounted(() => {
		queryListener();
	});

    return { screen, switchScreen }
}